import React, { memo } from 'react'
import { Button } from 'src/components/shared/Button'
import { useGigsafeRoleGate } from './useGigsafeRoleGate'

interface Props {
  formId: string
}

/**
 * The modal footer's submit. `CommonModal` portals the footer out of the `<Form>` element but
 * keeps it inside the Formik provider, so this reads the gate through context and submits by
 * `form` id.
 */
const GigsafeRoleSubmitButtonComponent = ({ formId }: Props) => {
  const { isDefaultRole, isCreating, isSaving } = useGigsafeRoleGate()

  return (
    <Button
      size="small"
      color="dark"
      type="submit"
      form={formId}
      loading={isSaving}
      disabled={isDefaultRole || isSaving}
      data-testid="gigsafe-role-submit-button"
    >
      {isCreating ? 'Create role' : 'Save role'}
    </Button>
  )
}

export const GigsafeRoleSubmitButton = memo(GigsafeRoleSubmitButtonComponent)
